/* Search drawer v2 + time-specific search message (Figma 6-5477).
   Moved from snippets/search-drawer.liquid so the ~11KB ships once,
   cached, instead of inline in every page's HTML (branch perf audit).
   Config arrives via data-* attributes on [data-search-drawer]. */
(function () {
  var root = document.querySelector('[data-search-drawer]');
  if (!root || root.dataset.sd2Init) return;
  root.dataset.sd2Init = 'true';

  // Time-of-day slogan for the navbar pill + drawer placeholder.
  // Loaded with defer, so the DOM (incl. the pill) is already parsed.
  var spMsgs = {
    morning: root.dataset.spMorning || '',
    afternoon: root.dataset.spAfternoon || '',
    evening: root.dataset.spEvening || '',
    night: root.dataset.spNight || ''
  };
  var h = new Date().getHours();
  var spMsg = h >= 5 && h < 12 ? spMsgs.morning
    : h >= 12 && h < 17 ? spMsgs.afternoon
    : h >= 17 && h < 21 ? spMsgs.evening
    : spMsgs.night;
  if (spMsg) {
    document.querySelectorAll('.nav2-search-pill__text').forEach(function (el) { el.textContent = spMsg; });
    document.querySelectorAll('[data-sd2-input]').forEach(function (el) { el.placeholder = spMsg; });
    // Mobile overlay mirrors the placeholder — see .sd2__ph in search-drawer.liquid.
    document.querySelectorAll('[data-sd2-ph-text]').forEach(function (el) { el.textContent = spMsg; });
  }

  // ── Mobile placeholder marquee ──
  // Clone the slogan and hand CSS the loop only when it's wider than the
  // pill's text window; otherwise it stays static so short slogans don't
  // crawl for no reason. Must run while the drawer is visible — everything
  // inside [hidden] measures 0.
  var phBox = root.querySelector('[data-sd2-ph]');
  var phTrack = root.querySelector('[data-sd2-ph-track]');
  function syncPlaceholderMarquee() {
    if (!phBox || !phTrack) return;
    var original = phTrack.firstElementChild;
    if (!original) return;
    // display:none (desktop, or a field with a value) measures 0 — leave the
    // existing state alone rather than resetting it to "doesn't overflow".
    var boxW = phBox.clientWidth;
    if (!boxW) return;
    var clone = phTrack.querySelector('[data-sd2-ph-clone]');
    // Measure the original alone; a leftover clone would double the width.
    if (clone) clone.remove();
    var textW = original.getBoundingClientRect().width;
    if (textW <= boxW) {
      phBox.classList.remove('is-scrolling');
      phBox.style.removeProperty('--sd2-ph-duration');
      return;
    }
    phBox.classList.add('is-scrolling');
    clone = original.cloneNode(true);
    clone.setAttribute('data-sd2-ph-clone', '');
    phTrack.appendChild(clone);
    // Constant ~45px/s regardless of slogan length, so a longer message
    // scrolls for longer rather than faster. +32px = the track's gap.
    phBox.style.setProperty('--sd2-ph-duration', ((textW + 32) / 45).toFixed(2) + 's');
  }
  window.addEventListener('resize', syncPlaceholderMarquee);

    var panelInput = root.querySelector('[data-sd2-input]');
    var clearBtn = root.querySelector('[data-sd2-clear]');
    var form = root.querySelector('[data-sd2-form]');
    var idleView = root.querySelector('[data-sd2-idle]');
    var resultsView = root.querySelector('[data-sd2-results]');
    var zeroView = root.querySelector('[data-sd2-zero]');
    var suggestionsEl = root.querySelector('[data-sd2-suggestions]');
    var productsEl = root.querySelector('[data-sd2-products]');
    var showAll = root.querySelector('[data-sd2-showall]');
    var termEls = root.querySelectorAll('[data-sd2-term], [data-sd2-zero-term]');
    var zeroMissingEls = root.querySelectorAll('[data-sd2-zero-missing]');
    var zeroSoldOutEls = root.querySelectorAll('[data-sd2-zero-soldout]');
    var moneyFormat = root.dataset.moneyFormat || '£{{amount}}';
    var searchUrl = root.dataset.searchUrl || '/search';
    var predictiveUrl = root.dataset.predictiveUrl || '/search/suggest';
    var debounceTimer = null;
    var lastQuery = '';
    // Short enough that the request overlaps the rest of the shopper's typing
    // rather than starting after it. Superseded requests are aborted, and
    // repeats are served from `answers` without a request at all.
    var DEBOUNCE_MS = 120;
    // How many product cards the grid shows. The request asks for more (see
    // predictiveJsonUrl) so sold-out rows can be dropped without thinning it.
    var SHOW_MAX = 6;

    function money(value) {
      var amount = parseFloat(value);
      if (isNaN(amount)) return value;
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount.toFixed(2));
    }

    // Struck compare-at price and "Save X%" badge, matching the product cards.
    // Predictive search returns prices as decimal strings ("49.95"), not cents
    // — same as money() above assumes — and exposes the compare-at as
    // compare_at_price_min. compare_at_price is checked too in case the shape
    // differs; both are parsed rather than compared as strings.
    function setCardPrice(el, p) {
      if (!el) return;

      var priceValue = parseFloat(p.price);
      var compareRaw = (p.compare_at_price_min === undefined || p.compare_at_price_min === null)
        ? p.compare_at_price
        : p.compare_at_price_min;
      var compareValue = parseFloat(compareRaw);
      var onSale = !isNaN(priceValue) && !isNaN(compareValue) && compareValue > priceValue;

      el.textContent = '';

      if (!onSale) {
        el.textContent = money(p.price);
        return;
      }

      var was = document.createElement('span');
      was.className = 'sd2__card-price-compare';
      was.textContent = money(compareRaw);

      var now = document.createElement('span');
      now.className = 'sd2__card-price-now';
      now.textContent = money(p.price);

      var saved = Math.round(((compareValue - priceValue) / compareValue) * 100) + '%';
      var savedTemplate = (window.theme && theme.strings && theme.strings.savePrice) || 'Save [saved_amount]';

      var save = document.createElement('span');
      save.className = 'sd2__card-price-savings';
      save.textContent = savedTemplate.replace('[saved_amount]', saved);

      el.appendChild(was);
      el.appendChild(now);
      el.appendChild(save);
    }

    function clearThemeSearchClasses() {
      // theme.js headerNav.searchDrawer() adds these for the old overlay
      // (now removed) — they dim/lock the page, so always strip them.
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
    }

    var tilesEl = root.querySelector('[data-sd2-tiles]');
    var tilesLoaded = false;

    function renderAutoTiles(products) {
      products.slice(0, 4).forEach(function (p) {
        if (!p || !p.images || !p.images.length) return;
        var a = document.createElement('a');
        a.className = 'sd2__tile';
        a.href = p.url || ('/products/' + p.handle);
        var img = document.createElement('img');
        img.className = 'sd2__tile-img';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = p.title || '';
        var base = p.images[0].src;
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        img.src = base + sep + 'width=480';
        img.srcset = base + sep + 'width=240 240w, ' + base + sep + 'width=380 380w, ' + base + sep + 'width=480 480w, ' + base + sep + 'width=560 560w';
        img.sizes = '(max-width: 664px) 189px, 231px';
        var shade = document.createElement('span');
        shade.className = 'sd2__tile-shade';
        shade.setAttribute('aria-hidden', 'true');
        var label = document.createElement('span');
        label.className = 'sd2__tile-label';
        label.textContent = p.title || '';
        a.appendChild(img); a.appendChild(shade); a.appendChild(label);
        tilesEl.appendChild(a);
      });
    }

    function loadTiles() {
      // Manual tile settings win; otherwise pull the best-sellers collection
      // (same source + in-stock filter + session cache as main's old search).
      if (tilesLoaded || !tilesEl || tilesEl.children.length > 0) { tilesLoaded = true; return; }
      tilesLoaded = true;
      var handle = tilesEl.dataset.sd2TilesCollection;
      if (!handle) return;
      try {
        var cached = sessionStorage.getItem('sd2-best-sellers-v2');
        if (cached) { renderAutoTiles(JSON.parse(cached)); return; }
      } catch (e) {}
      fetch('/collections/' + handle + '/products.json?limit=12')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products ? data.products : []).filter(function (p) {
            return p && p.variants && p.variants.some(function (v) { return v.available; });
          });
          if (!products.length) return;
          // Cache only what renderAutoTiles reads — the raw payload includes
          // body_html and every variant/image (tens of KB per product).
          var slim = products.slice(0, 8).map(function (p) {
            return {
              title: p.title,
              url: p.url,
              handle: p.handle,
              images: p.images && p.images.length ? [{ src: p.images[0].src }] : []
            };
          });
          try { sessionStorage.setItem('sd2-best-sellers-v2', JSON.stringify(slim)); } catch (e) {}
          renderAutoTiles(slim);
        })
        .catch(function () { /* tiles stay empty */ });
    }

    function open() {
      clearThemeSearchClasses();
      // Opening search is the intent signal: start building the typo
      // dictionary now (session-cached, no-op after the first time) so the
      // submit-time correction is ready by the time the query is typed.
      if (window.theme && typeof theme.warmSearchDictionary === 'function') {
        theme.warmSearchDictionary();
      }
      root.hidden = false;
      // Forced reflow instead of rAF: still animates the slide-in, but works
      // in hidden/background tabs where rAF callbacks never fire.
      void root.offsetWidth;
      root.classList.add('is-open');
      document.documentElement.classList.add('sd2-lock');
      // Legacy listeners (e.g. the cart-added toast) hide themselves on this
      // event — keep dispatching it so the toast still auto-hides.
      document.dispatchEvent(new CustomEvent('predictive-search:open', { bubbles: true }));
      loadTiles();
      // Re-sync on every open: the drawer can close without resetting the
      // field (Escape / X), and bfcache restores can desync button vs value.
      clearBtn.hidden = panelInput.value.trim().length === 0;
      // Now that the drawer is laid out, the overlay has a measurable width.
      syncPlaceholderMarquee();
      window.setTimeout(function () { panelInput.focus(); }, 320);
    }
    function close() {
      clearThemeSearchClasses();
      root.classList.remove('is-open');
      document.documentElement.classList.remove('sd2-lock');
      window.setTimeout(function () { root.hidden = true; }, 300);
    }

    function setView(state) {
      idleView.hidden = state !== 'idle';
      resultsView.hidden = state !== 'results';
      zeroView.hidden = state !== 'zero';
    }

    function setTerm(q) {
      termEls.forEach(function (el) { el.textContent = q; });
      showAll.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
    }

    // ── Hover second image (same behaviour as product cards) ──
    // The predictive API only returns the featured image, so the second
    // image is fetched lazily from /products/<handle>.js on first hover of
    // a card (cached per handle for the session). Like the product cards,
    // the swap only reveals once the image has loaded — until then the
    // primary image keeps showing (never a blank/white flash).
    var canHoverCards = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hoverImageCache = {}; // handle -> Promise<secondImageUrl|null>

    function secondImageFor(productUrl) {
      var handle;
      try {
        handle = new URL(productUrl, window.location.origin).pathname.split('/').pop();
      } catch (e) { return Promise.resolve(null); }
      if (!handle) return Promise.resolve(null);
      if (!hoverImageCache[handle]) {
        hoverImageCache[handle] = fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (prod) {
            return (prod && prod.images && prod.images.length > 1) ? prod.images[1] : null;
          })
          .catch(function () { return null; });
      }
      return hoverImageCache[handle];
    }

    // Warm /products/<handle>.js for the freshly rendered result cards during
    // idle time, so the second image is already cached before the first hover
    // (measured ~420ms fetch latency otherwise). Predictive returns ≤9 cards,
    // all visible; capped at 10 and deduped through the same per-handle cache
    // secondImageFor uses, so hover never refetches. Hover-capable only —
    // touch devices never show the swap.
    function prefetchHoverImages(products) {
      if (!canHoverCards || !products || !products.length) return;
      var run = function () {
        products.slice(0, 10).forEach(function (p) {
          if (p && p.url) secondImageFor(p.url);
        });
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1500 });
      } else {
        window.setTimeout(run, 300);
      }
    }

    function attachHoverImage(card, product) {
      card.addEventListener('mouseenter', function onEnter() {
        card.removeEventListener('mouseenter', onEnter);
        secondImageFor(product.url).then(function (src) {
          if (!src || !card.isConnected) return;
          var media = card.querySelector('.sd2__card-media');
          if (!media) return;
          var sep = src.indexOf('?') > -1 ? '&' : '?';
          var img = document.createElement('img');
          img.className = 'sd2__card-hover';
          img.decoding = 'async';
          img.alt = '';
          img.src = src + sep + 'width=480';
          img.srcset = src + sep + 'width=240 240w, ' + src + sep + 'width=360 360w, ' + src + sep + 'width=480 480w, ' + src + sep + 'width=720 720w';
          img.sizes = '(max-width: 768px) 45vw, 340px';
          // Reveal only once loaded — mirrors the product cards'
          // secondary-image--loaded gate.
          if (img.complete && img.naturalWidth > 0) {
            img.classList.add('is-loaded');
          } else {
            img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          }
          media.appendChild(img);
        });
      });
    }

    // Predictive's CDN urls carry a ?v= cache buster and no width, but Shopify
    // also hands out urls with the width baked in (image_url does), and two
    // width params fight — so replace rather than append.
    function withWidth(base, w) {
      var stripped = base.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
      return stripped + (stripped.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function render(data, q) {
      var products = data.products;
      var queries = data.queries;

      // Nothing to offer: either the catalogue has no match at all, or every
      // match is out of stock (data.soldOut). The drawer only offers what can
      // be bought, so both land on the zero state rather than padding the
      // grid with loosely-related products.
      if (!products.length && (data.soldOut || !queries.length)) {
        setTerm(q);
        // "We couldn't find X" is wrong when we did find it and it's sold out.
        var soldOut = !!data.soldOut;
        zeroMissingEls.forEach(function (el) { el.hidden = soldOut; });
        zeroSoldOutEls.forEach(function (el) { el.hidden = !soldOut; });
        setView('zero');
        return;
      }

      suggestionsEl.innerHTML = '';
      queries.slice(0, 6).forEach(function (item) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sd2__suggestion';
        b.innerHTML = item.styled_text || item.text;
        b.addEventListener('click', function () {
          panelInput.value = item.text;
          query(item.text);
        });
        suggestionsEl.appendChild(b);
      });

      productsEl.innerHTML = '';
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'sd2__card';
        a.href = p.url;
        var imgBase = (p.featured_image && p.featured_image.url) || p.image || '';
        a.innerHTML =
          '<span class="sd2__card-media">' + (imgBase ? '<img loading="lazy" decoding="async" alt="">' : '') + '</span>' +
          '<span class="sd2__card-title"></span>' +
          '<span class="sd2__card-colour"></span>' +
          '<span class="sd2__card-price"></span>';
        if (imgBase && canHoverCards) attachHoverImage(a, p);
        if (imgBase) {
          var cardImg = a.querySelector('img');
          cardImg.src = withWidth(imgBase, 480);
          // Cards render ~330px wide in the default 2-col layout of the
          // 720px-max panel — ~660 device px on retina. The old 480w
          // ceiling (with sizes=226px) forced an upscale and soft images.
          cardImg.srcset = withWidth(imgBase, 240) + ' 240w, ' + withWidth(imgBase, 360) + ' 360w, ' +
            withWidth(imgBase, 480) + ' 480w, ' + withWidth(imgBase, 720) + ' 720w';
          cardImg.sizes = '(max-width: 768px) 45vw, 340px';
          cardImg.alt = p.title || '';
        }
        a.querySelector('.sd2__card-title').textContent = p.title || '';
        a.querySelector('.sd2__card-colour').textContent = p.vendor || '';
        setCardPrice(a.querySelector('.sd2__card-price'), p);
        productsEl.appendChild(a);
      });

      setTerm(q);
      setView('results');
      prefetchHoverImages(products);
    }

    var inflight = null;

    // Wildcarding the term — "royal*" — switches Shopify's search from
    // semantic to lexical prefix matching. Unwildcarded, predictive answers
    // "royal" with Electric Blue and never returns the Royal Blue products at
    // all, at any limit; "royal*" returns exactly them. It is also what makes
    // part-typed words match while the shopper is still typing. Query
    // suggestions come back identical either way (verified on both stores),
    // so one call covers both halves of the panel.
    // A trailing * the shopper typed themselves is not doubled.
    function wildcard(q) {
      return q.replace(/\*+$/, '') + '*';
    }

    // Ask for the API maximum and show sold-out rows, then filter to SHOW_MAX
    // in stock below. Two reasons not to let unavailable_products=hide do it:
    // it filters on the search index, whose stock data lags (verified on the
    // US store — Vision Capris came back through that filter with 0 of 10
    // variants in stock), and it erases the difference between "the catalogue
    // doesn't have this" and "it does, but it's all sold out", which the
    // drawer needs to answer the shopper properly. Over-fetching also keeps
    // the grid full when some rows are dropped.
    function predictiveJsonUrl(q) {
      return predictiveUrl + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query' +
        '&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=show' +
        // tag is load-bearing: DFYNE colours live in product tags, so colour
        // queries ("red") return 0 products without it (verified against
        // /search/suggest.json — 0 vs 9 products for q=red).
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    }

    // The per-product `available` flag is accurate even when the hide filter
    // is not, so gate on it.
    function inStock(p) {
      return p.available !== false;
    }

    function results(json) {
      var res = (json && json.resources && json.resources.results) || {};
      return { products: res.products || [], queries: res.queries || [] };
    }

    function askPredictive(q, signal) {
      return fetch(predictiveJsonUrl(q), { headers: { 'Accept': 'application/json' }, signal: signal })
        .then(function (r) { return r.json(); })
        .then(results);
    }

    // Answers already fetched this page life. Keyed by the typed term, so
    // backspacing, retyping, clicking a suggestion and reopening the drawer
    // all repaint with no request at all. Deliberately in memory rather than
    // sessionStorage: stock moves, and a persisted answer could offer
    // something that has sold out since.
    var answers = Object.create(null);
    var answerKeys = [];
    function remember(q, data) {
      if (!(q in answers)) {
        answerKeys.push(q);
        // A long session shouldn't grow this without bound.
        if (answerKeys.length > 50) delete answers[answerKeys.shift()];
      }
      answers[q] = data;
    }

    function query(q) {
      lastQuery = q;
      clearBtn.hidden = q.length === 0;
      if (q.length < 2) {
        // Cancel any in-flight request when the query shrinks below the
        // threshold — otherwise a stale response could paint over 'idle'.
        if (inflight) { inflight.abort(); inflight = null; }
        setView('idle');
        return;
      }
      if (q in answers) {
        if (inflight) { inflight.abort(); inflight = null; }
        render(answers[q], q);
        return;
      }

      if (inflight) inflight.abort();
      inflight = new AbortController();
      var signal = inflight.signal;

      askPredictive(wildcard(q), signal)
        .then(function (wild) {
          var available = wild.products.filter(inStock).slice(0, SHOW_MAX);
          if (available.length) {
            return { products: available, queries: wild.queries };
          }
          if (wild.products.length) {
            // The catalogue does match the term — every match is just out of
            // stock ("papaya"). Say so with the zero state instead of padding
            // the grid with unrelated products a semantic pass would return.
            return { products: [], queries: wild.queries, soldOut: true };
          }
          // No lexical match at all ("sav", a typo): fall back to the
          // unwildcarded semantic search, which is what the results page
          // shows for these too.
          return askPredictive(q, signal).then(function (plain) {
            return {
              products: plain.products.filter(inStock).slice(0, SHOW_MAX),
              queries: plain.queries.length ? plain.queries : wild.queries
            };
          });
        })
        .then(function (data) {
          if (q !== lastQuery || signal.aborted) return;
          remember(q, data);
          render(data, q);
        })
        .catch(function () { /* aborted or network error — keep current view */ });
    }

    panelInput.addEventListener('input', function () {
      var q = panelInput.value.trim();
      // Visibility tracks the field synchronously — inside the debounced
      // query() it lagged 250ms and could stick visible on an empty field.
      clearBtn.hidden = q.length === 0;
      // Emptying the field brings the placeholder overlay back; open() can't
      // have measured it if the drawer opened with a value still in place.
      if (!panelInput.value) syncPlaceholderMarquee();
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () { query(q); }, DEBOUNCE_MS);
    });

    // Already on the search results page: route the new query through the
    // page's collection-grid AJAX engine so only the results area refreshes
    // (header/toolbar/nav stay mounted). Anywhere else, fall through to the
    // normal form navigation — the results section isn't in the DOM to swap.
    // Empty the search field once a query is committed, so the input never
    // lingers showing the last term (on the results page or on reopen).
    function resetInput() {
      panelInput.value = '';
      clearBtn.hidden = true;
      setView('idle');
    }

    function inPageSearch(q) {
      if (window.location.pathname !== searchUrl) return false;
      var grid = window.theme && theme.activeCollectionGrid;
      if (!grid || typeof grid.runSearch !== 'function') return false;
      if (!grid.container || !grid.container.isConnected) return false;
      grid.runSearch(q);
      close();
      resetInput();
      return true;
    }

    // Confident typo corrections apply AT SUBMIT ("greeeeen" → green) so the
    // search goes straight to the corrected results — without this the wrong
    // page rendered first and theme.js location.replace'd it a beat later
    // (a visible double reload). theme.searchAutoCorrect also records the
    // "you searched for" notice; it returns null when the term is fine or
    // the session dictionary isn't built yet (theme.js then corrects
    // post-load as before).
    function maybeCorrect(q) {
      if (window.theme && typeof theme.searchAutoCorrect === 'function') {
        return theme.searchAutoCorrect(q) || q;
      }
      return q;
    }

    form.addEventListener('submit', function (evt) {
      // The default GET submission is never used: it serialises the input
      // AFTER handlers run, which forced a deferred field clear
      // (setTimeout 0) that raced the navigation commit — the typed text
      // visibly lingered in the drawer until the results page painted.
      // Navigating manually lets the field clear synchronously (the text
      // vanishes the instant Enter is pressed) and carries type=product so
      // the landing page skips its client-side products-only redirect.
      evt.preventDefault();
      var q = panelInput.value.trim();
      if (q.length === 0) return;
      q = maybeCorrect(q);
      if (!inPageSearch(q)) {
        // Same exit as the in-page path: close the drawer immediately -
        // without this it sat open (empty, idle view) until the results
        // page painted, which read as "search didn't do anything".
        close();
        resetInput();
        window.location.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      }
    });

    showAll.addEventListener('click', function (evt) {
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      var q = panelInput.value.trim();
      if (!q) return;
      var corrected = maybeCorrect(q);
      if (corrected !== q) {
        q = corrected;
        // href was built from the typed term (setTerm) — rebuild it so the
        // native link navigation also lands on the corrected query.
        showAll.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      }
      if (inPageSearch(q)) evt.preventDefault();
      else resetInput();
    });

    clearBtn.addEventListener('click', function () {
      panelInput.value = '';
      clearBtn.hidden = true;
      setView('idle');
      panelInput.focus();
    });

    root.querySelectorAll('[data-sd2-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keyup', function (evt) {
      if (!root.isConnected) return; // stale instance after section re-render
      if (evt.key === 'Escape' && !root.hidden) close();
    });

    root.querySelectorAll('[data-sd2-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        panelInput.value = pill.textContent.trim();
        form.requestSubmit();
      });
    });

    root.querySelectorAll('[data-sd2-cols]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-sd2-cols]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        productsEl.classList.remove('sd2__products--2', 'sd2__products--3');
        productsEl.classList.add('sd2__products--' + btn.dataset.sd2Cols);
        try { sessionStorage.setItem('sd2Cols', btn.dataset.sd2Cols); } catch (e) {}
      });
    });
    try {
      var savedCols = sessionStorage.getItem('sd2Cols');
      if (savedCols) {
        var btn = root.querySelector('[data-sd2-cols="' + savedCols + '"]');
        if (btn) btn.click();
      }
    } catch (e) {}

    // Opening the cart (or nav) drawer while the search panel is up left the
    // sd2 panel + backdrop sitting underneath the theme drawer, so the cart
    // appeared over a white search panel instead of the standard page dim.
    // Close the search drawer whenever a theme drawer trigger is clicked.
    document.addEventListener('click', function (evt) {
      if (!root.isConnected || root.hidden) return;
      var drawerTrigger = evt.target && evt.target.closest
        ? evt.target.closest('.js-drawer-open-cart, .js-drawer-open-nav')
        : null;
      if (drawerTrigger) close();
    }, true);

    // Capture phase: runs BEFORE theme.js's element-level .js-search-header
    // handler (which calls stopPropagation + opens the removed old overlay).
    document.addEventListener('click', function (evt) {
      if (!root.isConnected) return; // stale instance after section re-render
      if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      var trigger = evt.target && evt.target.closest ? evt.target.closest('.js-search-header') : null;
      if (!trigger) return;
      evt.preventDefault();
      evt.stopPropagation();
      open();
    }, true);
  })();
